//import external libraries
import React, { useEffect, useState } from "react";
import { PDFViewer, BlobProvider } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";
//import internal resources and libraries
import {
  getCalculations,
  getCalculationsByAdmin,
} from "../utils/services/projectService";
import ProluxTechCardContent from "./ProluxTechCardContent";
//import MUI components
import { useTheme } from "@mui/material/styles";
import DescriptionIcon from "@mui/icons-material/Description";

const TechCardProlux = React.memo(
  ({ id, revNum, heatRecovery, cardContent, admin }) => {
    const [techData, setTechData] = useState(cardContent);

    const [docName, setDocName] = useState("TechnischesDatenblatt");

    const theme = useTheme();

    useEffect(() => {
      if (cardContent != undefined)
        setDocName(
          docName +
            "_Project-" +
            cardContent.project +
            "_Position-" +
            cardContent.system +
            "_rev-" +
            cardContent.revision
        );
      if (
        cardContent == undefined &&
        id !== undefined &&
        revNum !== undefined
      ) {
        if (!admin) {
          getCalculations(id, revNum).then((res) => {
            setTechData(res.data.data);
            setDocName(
              docName +
                "_Project-" +
                res.data.data.project +
                "_Position-" +
                res.data.data.system +
                "_rev-" +
                res.data.data.revision
            );
          });
        } else {
          getCalculationsByAdmin(id, revNum).then((res) => {
            setTechData(res.data.data);
            setDocName(
              docName +
                "_Project-" +
                res.data.data.project +
                "_Position-" +
                res.data.data.system +
                "_rev-" +
                res.data.data.revision
            );
          });
        }
      } else return;
    }, [id, revNum]);

    if (
      techData == undefined ||
      techData == null //||
    )
      return null;
    return (
      <BlobProvider
        document={
          <ProluxTechCardContent
            id={id}
            techData={techData}
            revNum={revNum}
            heatRecovery={heatRecovery}
            tittle={`${docName}.pdf`}
          />
        }
        fileName={`${docName}.pdf`}
      >
        {({ url, loading, error }) => {
          /*   if (loading) {
            console.log("ucitava");
          }*/
          if (!loading && url) {
            return (
              <a href={url} download={`${docName}.pdf`}>
                <DescriptionIcon
                  sx={{
                    color: "black",

                    width: "26px",
                  }}
                />
              </a>
            );
          }
          if (error) {
            console.error(error);
            return <p>An error occurred</p>;
          }
          return null;
        }}
      </BlobProvider>
    );
  }
);

export default TechCardProlux;
